theme.headerMainMenuModule = (function () {
  function mainMenu() {
    let menuLiSelector = document.querySelectorAll(".header__menu_li");
    menuLiSelector.forEach((item) => {
      if (item.classList.contains("menu__item_has_children")) {
        let listDetails = item.querySelector("details");
        let closeTimeout;

        // Prevent details from toggling on summary click
        item.querySelector("summary").addEventListener("click", (event) => {
          event.preventDefault();
          const href = event.currentTarget.dataset.href;
          if (href) {
            window.location.href = `${window.location.origin}${href}`;
          }
        });

        // Open on hover
        item.addEventListener("mouseenter", () => {
          clearTimeout(closeTimeout);
          listDetails.setAttribute("open", "");
          item.querySelector("summary").setAttribute("aria-expanded", "true");
        });

        // Close on mouse leave — with delay so user can reach submenu
        item.addEventListener("mouseleave", () => {
          closeTimeout = setTimeout(() => {
            listDetails.removeAttribute("open");
            item.querySelector("summary").setAttribute("aria-expanded", "false");
          }, 600); // 300ms delay — adjust if needed
        });
      }
    });
  }
  return mainMenu;
})();
